import { FC } from 'react';

interface CheckCircleIconProps {
  size?: number;
  color?: string;
  title?: string;
}

export const CheckCircleIcon: FC<CheckCircleIconProps> = ({
  size = 18,
  color = '#a0c002',
  title,
}) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    {title && <title>{title}</title>}
    <circle cx="12" cy="12" fill={color} r="11" />
    <path
      d="M7 12L10.5 15.5L17 9"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.5"
    />
  </svg>
);
